"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var react_2 = require("@transifex/react");
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("./utils");
var icons_1 = require("../../../icons");
var common_1 = require("../layers/common");
var transifex_1 = require("../../../transifex");
var StyledTitle = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 14px;\n  font-weight: 400;\n  margin-top: 3px;\n  margin-left: 8px;\n"], ["\n  font-size: 14px;\n  font-weight: 400;\n  margin-top: 3px;\n  margin-left: 8px;\n"])));
var StyledLocation = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: #707780;\n  font-size: 12px;\n  font-weight: 400;\n"], ["\n  color: #707780;\n  font-size: 12px;\n  font-weight: 400;\n"])));
var WasteDepotTooltip = function (_a) {
    var type = _a.type, location = _a.location;
    var depotSvg = common_1.getSvgImageSrc(function () { return (react_1.default.createElement(icons_1.DepotMarker, { size: 15, color: "#0090FF" })); });
    var wasteStation = common_1.getSvgImageSrc(function () { return (react_1.default.createElement(icons_1.WasteStationMarker, { size: 15, color: "#0090FF" })); });
    return (react_1.default.createElement(antd_1.Row, { style: { minWidth: 204, maxWidth: 204 } },
        react_1.default.createElement(antd_1.Col, { xs: 24 },
            react_1.default.createElement(antd_1.Row, null,
                react_1.default.createElement(antd_1.Col, { xs: 3 },
                    react_1.default.createElement("img", { src: type === "depot" ? depotSvg : wasteStation, width: "24px", height: "24px", alt: "depot" })),
                react_1.default.createElement(antd_1.Col, { xs: 18 },
                    react_1.default.createElement(StyledTitle, null,
                        type === "depot" && transifex_1.TX_DEPOT,
                        type !== "depot" && transifex_1.TX_WASTE_STATION))),
            react_1.default.createElement(antd_1.Row, null,
                react_1.default.createElement(antd_1.Col, { xs: 24 },
                    react_1.default.createElement(StyledLocation, null,
                        react_1.default.createElement(react_2.T, { _str: utils_1.getValue(location === null || location === void 0 ? void 0 : location.name) })))))));
};
exports.default = WasteDepotTooltip;
var templateObject_1, templateObject_2;
